import { DivEmailContent, DivItemGloboAds } from '../styles';

export const ItemGloboAds = () => {
  return (
    <DivItemGloboAds key="globoads-web">
      <p>
        Solicite via e-mail, a desvinculação do <strong>Globo Ads</strong> da
        sua conta.
      </p>
      <p>
        Ao realizar essa ação, você perderá o acesso ao Globo Ads, por isso,{' '}
        <strong>
          recomendamos que não tenha nenhuma campanha ativa antes de prosseguir.
        </strong>
      </p>
      <p>
        Para solicitar a desvinculação, envie um e-mail para{' '}
        <strong>globoads@g.globo</strong> com o seguinte assunto e corpo de
        e-mail:
      </p>
      <DivEmailContent>
        <p>
          <em>Assunto</em>: Solicitação de desvinculação do Globo Ads
        </p>
        <p>
          <em>Corpo do e-mail</em>:
        </p>
        <p>Gostaria de desvincular minha conta do Globo Ads.</p>
        <ul>
          <li>E-mail cadastrado: (exemplo@email.com)</li>
          <li>CNPJ: (00.000.000/0000-00)</li>
        </ul>
      </DivEmailContent>
      <p>
        O prazo para processamento é de até 2 dias úteis. Você receberá a
        confirmação da desvinculação pelo e-mail globoads@g.globo.
      </p>
    </DivItemGloboAds>
  );
};
